import React, { useCallback, useEffect, useMemo } from 'react';
import { debounce } from 'lodash';
import { CardView, SettingsItemNavigate, SettingsItemTitle, } from 'design-system';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { IconScan } from 'design-system/icons';
import { muteErrorAndFetching, useFetchOld } from 'hooks';
import { getFilterPreview } from 'actions';
export const SmartRuleDetectedTransactions = ({ filters }) => {
    const navigation = useMainStackNavigation();
    const [result, , , fetch] = useFetchOld(muteErrorAndFetching);
    const debouncedChangeHandler = useMemo(() => debounce((body) => fetch(getFilterPreview(body, undefined)), 300), []);
    const { minAmount, maxAmount } = filters;
    const isAmountRangeInvalid = Boolean(minAmount && maxAmount && minAmount > maxAmount);
    useEffect(() => {
        if (filters.counterpartRegex && !isAmountRangeInvalid) {
            debouncedChangeHandler({
                ...filters,
                accountIds: `[${filters.accountIds.join(',')}]`,
            });
        }
        return () => debouncedChangeHandler.cancel();
    }, [debouncedChangeHandler, filters, isAmountRangeInvalid]);
    const onPress = useCallback(() => {
        navigation.navigateDeprecated('SmartRuleDetectedTransactions', filters);
    }, [filters]);
    const total = filters.counterpartRegex && !isAmountRangeInvalid
        ? result?.paging.totalCount ?? 0
        : 0;
    return (<CardView noMarginTop webPadding>
      <SettingsItemNavigate disabled={!total} icon={<IconScan colorKey="positive"/>} title={<SettingsItemTitle>{total}</SettingsItemTitle>} description="Detected transactions" onPress={onPress}/>
    </CardView>);
};
